import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/mobile.css'
import './i18n'
import { GlobalErrorBoundary } from './components/common/GlobalErrorBoundary'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { env } from './config/env'
import { BrowserRouter } from 'react-router-dom'

// 🔥 App como import LAZY para evitar que Vite se cuelgue
// transformando los 3000+ módulos del árbol de dependencias
const App = React.lazy(() => import('./App'))

// 🛡️ Service Worker — Register in production, purge in development
if ('serviceWorker' in navigator) {
    if (import.meta.env.PROD) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js')
                .then(reg => console.log('[APEX] Service Worker registered:', reg.scope))
                .catch((err: unknown) => console.warn('[APEX] SW registration failed:', err));
        });
    } else {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (const registration of registrations) {
                registration.unregister();
            }
        }).catch(() => { /* dev cleanup */ });
    }
}

// Inicialización lazy de servicios no críticos
setTimeout(() => {
    import('./services/localDB')
        .then(m => { try { m.localDB.initializeDemoData(); } catch (e) { console.warn('[APEX] localDB:', e); } })
        .catch((e: unknown) => console.warn('[APEX] localDB:', e));

    import('./services/engine/seedQuotes')
        .then(m => { try { m.seedQuotesEntity(); } catch (e) { console.warn('[APEX] seedQuotes:', e); } })
        .catch((e: unknown) => console.warn('[APEX] seedQuotes:', e));

    import('./config/sentry')
        .then(m => { try { m.initSentry(); } catch (e) { console.warn('[APEX] Sentry:', e); } })
        .catch((e: unknown) => console.warn('[APEX] Sentry:', e));
}, 500);

// Loading screen mientras App carga
function LoadingScreen() {
    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#0a0a1a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column' as const,
            gap: '1rem',
        }}>
            <div style={{
                width: '48px',
                height: '48px',
                border: '3px solid rgba(239, 68, 68, 0.2)',
                borderTopColor: '#ef4444',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite',
            }} />
            <p style={{
                color: 'rgba(255,255,255,0.4)',
                fontFamily: 'monospace',
                fontSize: '12px',
                letterSpacing: '0.2em',
                textTransform: 'uppercase' as const,
            }}>Cargando plataforma...</p>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
}

// MONTAJE DE REACT
const rootElement = document.getElementById('root');

if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
            <GlobalErrorBoundary>
                <GoogleOAuthProvider clientId={env.GOOGLE_CLIENT_ID || 'dummy'}>
                    <BrowserRouter>
                        <Suspense fallback={<LoadingScreen />}>
                            <App />
                        </Suspense>
                    </BrowserRouter>
                </GoogleOAuthProvider>
            </GlobalErrorBoundary>
        </React.StrictMode>
    );
} else {
    console.error('[APEX FATAL] No se encontró #root en el DOM');
}
